// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2vDhb","insightsList":"newBusinessInsightsMenu_insightsList__1Cfmx","active":"newBusinessInsightsMenu_active__PGgiO"};